"use strict";

var _interopRequireWildcard = require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;

var _interopRequireDefault = require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime.js");

var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));

var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));

var Settings = _interopRequireWildcard(require("@/model/settings"));

var _i18n = require("@/assets/js/i18n");

var _InputNumber = _interopRequireDefault(require("@/components/common/InputNumber"));

var _security = require("@/model/user/security");

var _forgetPwd = require("@/model/user/forgetPwd");

var _message = require("@/components/dialog/message");

var _routeSplicing = _interopRequireDefault(require("@/assets/js/routeSplicing"));

var _vuex = require("vuex");

var _globalFun = _interopRequireDefault(require("@/assets/js/globalFun.js"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import Code from "./Code";
var _default2 = {
  props: {
    isInCheck: {
      type: Boolean,
      default: false
    },
    validInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      emailCountDown: {
        countDown: -1,
        // 倒计时计数
        countDownTimer: null,
        // 倒计时容器
        countDownStatus: false // 倒计时点击状态

      },
      mobileCountDown: {
        countDown: -1,
        // 倒计时计数
        countDownTimer: null,
        // 倒计时容器
        countDownStatus: false // 倒计时点击状态

      },
      user_id: "",
      all_areacode: [],
      // 所有区号
      forgetData: {
        area: 86
      },
      formRules: {
        mobile_code: [{
          required: true,
          message: this.translateTitle("\u8BF7\u8F93\u5165\u6B63\u786E\u76846\u4F4D\u624B\u673A\u9A8C\u8BC1\u7801"),
          trigger: "blur"
        }, {
          pattern: /^\d{6}$/,
          message: this.translateTitle("\u8BF7\u8F93\u5165\u6B63\u786E\u76846\u4F4D\u624B\u673A\u9A8C\u8BC1\u7801"),
          trigger: "blur"
        }],
        email_code: [{
          required: true,
          message: this.translateTitle("\u8BF7\u8F93\u5165\u6B63\u786E\u76846\u4F4D\u90AE\u7BB1\u9A8C\u8BC1\u7801"),
          trigger: "blur"
        }, {
          pattern: /^\d{6}$/,
          message: this.translateTitle("\u8BF7\u8F93\u5165\u6B63\u786E\u76846\u4F4D\u90AE\u7BB1\u9A8C\u8BC1\u7801"),
          trigger: "blur"
        }],
        google_code: [{
          required: true,
          message: this.translateTitle("\u8BF7\u8F93\u5165\u6B63\u786E\u76846\u4F4D\u8C37\u6B4C\u9A8C\u8BC1\u7801"),
          trigger: "blur"
        }, {
          pattern: /^\d{6}$/,
          message: this.translateTitle("\u8BF7\u8F93\u5165\u6B63\u786E\u76846\u4F4D\u8C37\u6B4C\u9A8C\u8BC1\u7801"),
          trigger: "blur"
        }]
      },
      valid: {
        email: true,
        mobile: true,
        google: false,
        username: true
      },
      forgetLoading: false,
      mobileCounting: false,
      emailCounting: false,
      globalFun: _globalFun.default
    };
  },
  created: function created() {
    var _this = this;

    this.getAreaCode();

    document.onkeyup = function (e) {
      var keycode = document.all ? event.keyCode : e.which; // 在登录界面 且 按得键是回车键enter

      if (_this.$route.path == "/forgetPwd" && keycode === 13) {
        _this.handSubmit();
      }
    };
  },
  watch: {
    validInfo: {
      handler: function handler(val) {
        this.forgetData.email = val.email;
        this.forgetData.mobile = val.mobile;
      },
      immediate: true
    }
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)({
    language: "user/language"
  })),
  methods: {
    routeSplicing: _routeSplicing.default,
    translateTitle: _i18n.translateTitle,
    onToForget: function onToForget() {
      this.$emit("onCancel");
    },
    onSercuity: function onSercuity() {
      // this.$router.push(this.routeSplicing(this.language, "loginSecurity"));
      this.$router.push({
        path: this.routeSplicing(this.language, "loginSecurity"),
        query: {
          type: "formForgotPassword"
        }
      });
    },
    // 发送手机验证码
    onMobileSendCode: function onMobileSendCode() {
      var _this2 = this;

      var data = {
        // type: 23,
        // mobile: this.validInfo.mobile,
        // area: this.validInfo.area,
        // user_id: this.validInfo.user_id,
        token: this.validInfo.token
      };
      (0, _security.sendForgetSmsCode)(data).then(function (rs) {
        if (rs.status == 200) {
          _this2.mobileCounting = true;
          (0, _message.showMessage)({
            message: _this2.translateTitle("\u53D1\u9001\u6210\u529F"),
            type: "success"
          });
          _this2.mobileCountDown.countDown = 60;
          _this2.mobileCountDown.countDownTimer = setInterval(function () {
            if (_this2.mobileCountDown.countDown === 0) {
              clearInterval(_this2.mobileCountDown.countDownTimer);
              _this2.mobileCountDown.countDownStatus = false;
            }

            _this2.mobileCountDown.countDown--;
          }, 1000);
        } else {
          _this2.mobileCountDown.countDownStatus = false;
        }
      });
    },
    // 发送邮箱验证码
    onEmailSendCode: function onEmailSendCode() {
      var _this3 = this;

      var data = {
        // type: 24,
        // email: this.validInfo.email,
        // user_id: this.validInfo.user_id,
        token: this.validInfo.token
      };
      (0, _security.sendForgetEmailCode)(data).then(function (rs) {
        if (rs.status == 200) {
          _this3.emailCounting = true;
          (0, _message.showMessage)({
            message: _this3.translateTitle("\u53D1\u9001\u6210\u529F"),
            type: "success"
          });
          _this3.emailCountDown.countDown = 60;
          _this3.emailCountDown.countDownTimer = setInterval(function () {
            if (_this3.emailCountDown.countDown === 0) {
              clearInterval(_this3.emailCountDown.countDownTimer);
              _this3.emailCountDown.countDownStatus = false;
            }

            _this3.emailCountDown.countDown--;
          }, 1000);
        } else {
          _this3.emailCountDown.countDownStatus = false;
        }
      });
    },
    handSubmit: function handSubmit() {
      var _this4 = this;

      this.$refs.validatorForm.validate(function (valid) {
        if (valid) {
          _this4.forgetLoading = true; // 检测是否存在该账号

          var data = {};
          var _this4$validInfo = _this4.validInfo,
              token = _this4$validInfo.token,
              validate_email = _this4$validInfo.validate_email,
              validate_google = _this4$validInfo.validate_google,
              validate_mobile = _this4$validInfo.validate_mobile,
              email = _this4$validInfo.email,
              mobile = _this4$validInfo.mobile,
              user_id = _this4$validInfo.user_id,
              username = _this4$validInfo.username;
          data.token = token; // data.user_id = user_id;

          if (validate_email == 1) {
            // (data.email = email),
            data.email_code = _this4.forgetData.email_code;
          }

          if (validate_mobile == 1) {
            // (data.mobile = mobile),
            data.mobile_code = _this4.forgetData.mobile_code;
          }

          if (validate_google == 1) {
            // (data.username = username),
            data.google_code = _this4.forgetData.google_code;
          }

          (0, _forgetPwd.submitForgetUniversal)(data).then(function (rs) {
            _this4.forgetLoading = false;

            if (rs.status == 200) {
              _this4.$emit("secret", rs.data.token);
            }
          });
        }

        return;
      });
    },

    /* 获取手机区号 */
    getAreaCode: function getAreaCode() {
      var _this5 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$Settings$apiGe, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Settings.apiGetStaticTableInfo(Settings.SETTING_SV_ID.static_sms_country);

              case 2:
                _yield$Settings$apiGe = _context.sent;
                data = _yield$Settings$apiGe.data;

                if (data) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return", false);

              case 6:
                _this5.all_areacode = data;

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  },
  components: {
    InputNumber: _InputNumber.default
  }
};
exports.default = _default2;